<template>
  <toast v-model="showToast" v-if="showToast" :msg="msg"></toast>
</template>
<script>
import { mapState } from 'vuex'
import Toast from '@/components/Toast'
import { fetchHouse, fetchBrandHouse, fetchFavirote, doFavirote, searchHouse, fetchHouseNew } from '@/services/house.js'
import { errorReport } from '@/utils/index.js'
import { base64Encode } from '@/utils/base64'
import Cookies from 'js-cookie'
import tujialogin from '@/utils/tujialogin.js'
import { wrapAuthorizeUrl } from '@common-libs/tj-channel/elong'
import { mpUtils } from '@tujia/fe-lib-bridge'
import { channelTypes } from '@common-libs/tj-channel'
import { eventBus } from '@/utils'
import { outcodeHandler } from '@/utils/outcodeHandler'
import tjCookie from '@/utils/tjCookie'


const u = navigator.userAgent
const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

export default {
  mixins: [tujialogin],

  components: {
    Toast
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      showToast: false,
      msg: 'hello world'
    }
  },
  computed: {
    ...mapState(['houseFilter']),
    filterCondition() {
      return this.houseFilter.checkInDate + this.houseFilter.checkOutDate + this.houseFilter.onlyCanBooking + this.houseFilter.cityId
    },
    judgeIsTuJiaAppEnv(){
      return this.platformEnv?.isTujiaAppEnv &&  ['0', '2'].includes(this.compProps.houseChoice)
    }
  },
  watch: {
    async payLoad(newVal) {
    // eslint-disable-next-line
      if (newVal && newVal.type === 'openHouseInfo') {
        this.showHouseInfo(newVal.data, newVal.checkInDate, newVal.checkOutDate)
      } else if (newVal && newVal.type === 'favoriteHouse') {
        try {
          // 收藏手动埋点 gio html属性埋点方式bi找不到
          const trackName = `${this.$root.isMobile ? 'H5' : 'PC'}_favorite_cms`
          const trackData = {
            'promotionId': this.$root.promotionId,
            'houseId': newVal.data.id,
            'isLike': newVal.data.isLike ? '取消' : '收藏'
          }
          window._vds && window._vds.track(trackName, trackData)
          window._fas && window._fas.setCustomTrack({ eventname: trackName, ext: trackData })
        } catch (error) {
          console.log('_vds.track', error)
        }

        await this.doFavorite(newVal.data)
      }
    },
    filterCondition(newV, oldV) {
      if (newV !== oldV) {
        // 非专属房源
        if (this.compProps.houseChoice !== '3') {
          this.initHouses()
        }
      }
    }
  },
  async mounted() {
    this.initHouses()
  },
  methods: {
    /**
     * 跳转房屋详情
     * @param {Number} unitId 房屋id
     * @param {String} startDate 开始时间
     * @param {String} endDate 结束时间
     * dg=1 m站展示打开app按钮
     */
    async showHouseInfo(unitId, startDate, endDate) {
      const { isJumpApp } = this.compProps
      let moment = require('moment')
      startDate = startDate || moment().format('YYYY-MM-DD')
      endDate = endDate || moment().add('days', 1).format('YYYY-MM-DD')
      const { code = `cms_${this.$root.promotionId}` } = this.$route.query
      try {
        let atmQuery = ''
        if (this.$root.atm_source) {
          atmQuery = `&atm_source=${this.$root.atm_source}`
        }
        // 正常情况下需要传递日期给后端，但是该页面为配置页面，没有具体业务。所以需要后端接口抹平
        const { isWxMpEnv, isTujiaAppEnv, isCtripAppEnv, isQunarAppEnv, isAlipayClient, isMayiAppEnv } = this.platformEnv
        if (isMayiAppEnv) {
          // 跳转客户端房屋详情
          window.location.href = `https://app.tujia.com/go/unitdetail?id=${unitId}&start=${startDate}&end=${endDate}&isFromPromotion=true${atmQuery}&channelId=${code}`
        } else if (isTujiaAppEnv) {
          const outcode = outcodeHandler(this.$route.query)
          const urlOutCode = outcode ? `&outcode=${outcode}` : ''
          // 跳转客户端房屋详情
          window.location.href = `tujia://crn?page=ProductPage&module=rn_product_detail&initialPage=ProductPage&houseId=${unitId}&checkin=${startDate}&checkout=${endDate}&channelId=${code}${urlOutCode}`
        } else if (isWxMpEnv) {
          // 跳转小程序房屋详情
          const h5url = `https://m.tujia.com/detail/${unitId}.htm?beginDate=${startDate}&endDate=${endDate}${atmQuery}&code=${code}&tjchannelid=${this.tjChannelId}&dg=1`
          const wxUrl = this.tjChannelId === channelTypes.ELONG ? `/page/home/webview/webview?src=${encodeURIComponent(wrapAuthorizeUrl(h5url))}` : `/pages/tbnb/pages/main/housedetail/index?beginDate=${startDate}&endDate=${endDate}&unitId=${unitId}&code=${code}`
          mpUtils.navigateTo({
            url: wxUrl
          })
        } else if (isAlipayClient) {
        // 支付宝webview ua
          this.jumpAliClientAndMP(unitId, isJumpApp)
        } else if (isCtripAppEnv) {
          // 携程详情页
          let url = `/rn_bnb_order/main.js?CRNType=1&CRNModuleName=TuJiaApp&initialPage=ProductPage&houseId=${unitId}&checkin=${startDate}&checkout=${endDate}&channelId=${code}`
          window.location.href = `ctrip://wireless/h5?url=${base64Encode(url)}&type=5`
        } else if (isQunarAppEnv) {
          // 跳转去哪详情页
          const url = `qunar${isIos ? 'i' : 'a'}phone://react/open?hybridId=tj_product_detail_rn&pageName=ProductPage&initProps=${encodeURIComponent(JSON.stringify({ param: { houseId: `${unitId}` } }))}`
          window.location.href = url
        } else {
        // 移动端浏览器跳转房屋详情
          if (this.$root.isMobile) {
            Cookies.set(`${process.env.VUE_APP_TUJIA_DOMAIN}_MobileContext_StartDate`, startDate, { domain: process.env.VUE_APP_TUJIA_DOMAIN })
            Cookies.set(`${process.env.VUE_APP_TUJIA_DOMAIN}_MobileContext_EndDate`, endDate, { domain: process.env.VUE_APP_TUJIA_DOMAIN })

            // 2019-06-07 暑期大促 新加跳转app 和 支付宝小程序的方法
            if (isJumpApp) {
              // console.log('registerAppLauncherForUnit1', unitId)
              window.location.href = `tujia://com.tujia.hotel/unitdetail?id=${unitId}&start=${startDate}&end=${endDate}`
              this.autoLinkApp(`${this.mTujiaHost}/detail/${unitId}.htm?dg=1`)
            } else {
              window.location.href = `${this.mTujiaHost}/detail/${unitId}.htm?beginDate=${startDate}&endDate=${endDate}${atmQuery}&code=${code}&tjchannelid=${this.tjChannelId}&dg=1`
            }
          } else {
            window.location.href = `${this.pcTujiaHost}/detail/${unitId}.htm?startDate=${startDate}&endDate=${endDate}${atmQuery}&code=${code}`
          }
        }
      } catch (e) {
        errorReport(e)
      }
    },
    /**
     * 收藏
     * @param {Object} house 房屋
     */
    async doFavorite(house) {
      try {
        const isLogin = await this.isLogin()
        if (!isLogin) {
          this.goLoginPage()
          return
        }
        const ret = await doFavirote(house.id, house.isLike)
        if (ret && ret.errcode === 0) {
          this.$emit('finish', { type: 'favirote', data: { id: house.id, isLike: !house.isLike } })
        }
      } catch (e) {
        this.msg = '系统开小差了，一会再试试吧'
        this.showToast = true
        errorReport(e)
      }
    },
    /**
     * 初始化房屋信息
     */
    async initHouses() {
      try {
        const ids = []
        let ret = null
        let noHavePriceHouse = {}
        const maxShowNumber = this.compProps.maxShowNumber
        // houseChoice：0-房屋组，1-代表选用商户id获取房屋，2-搜索系统，3-专属房源
        if (this.compProps.houseChoice === '1') { // 商户id获取房屋
          let landlordIds = []
          this.compProps.landlordIds && this.compProps.landlordIds.split(',').forEach((element) => {
            landlordIds.push(+element)
          })
          const { cityId = '' } = this.$route.query
          const params = {
            cityId: +cityId || 0,
            landlordIds: landlordIds || [],
            defaultBetweenDays: +this.compProps.priceTime,
            pagesize: +maxShowNumber,
            pageIndex: +this.compProps.pageIndex || 1,
            needNoRepositoty: this.compProps.needNoRepositoty
          }
          ret = await fetchBrandHouse(params)
        } else if (this.compProps.houseChoice === '0') { // 房屋组
          /**
           * 存cookie，用于node的侧获取房屋价格，用于客户端展示价格一致
           * TOC-9086【T增长】CMS房屋卡片报价不一致 通过Cookies中的 tj_channel_wrapper_id 判断
           */
          if(!Cookies.get('tj_channel_wrapper_id') && this.judgeIsTuJiaAppEnv) {
            Cookies.set('tj_channel_wrapper_id', 'waptujia001')
          }

          this.compProps.houses.forEach((house) => {
            ids.push(house.id)
          })
          const aIds = this.compProps.promotionId && this.compProps.promotionId.split(',')
          // 有筛选栏时，不可订房屋
          const notOrderableFilter = this.houseFilter.visible && !this.houseFilter.onlyCanBooking && this.compProps.needNoRepositoty
          // 无筛选栏时，不可订房屋
          const notOrderable = !this.houseFilter.visible && this.compProps.needNoRepositoty
          /**
           * TOC-5607 H5配置后台功能增强一期C - 房屋列表增加选项
           * 城市是否收全局城市控制，因为线上是默认受控的，为了保持线上一致
           * 所以 isCityControl 为 false， 为不受控
           * 其他值都为受控
           */
          const cityId = this.compProps.isCityControl === false ? undefined: this.houseFilter.cityId
          if (notOrderableFilter || notOrderable) { // 不可订
            ret = await this.fetchHouseHandle(this.compProps.isOutOfOrder ? this.changeSort(ids) : ids, aIds || [], this.compProps.priceTime, maxShowNumber, this.$root.promotionId,
              this.houseFilter.visible ? !this.houseFilter.onlyCanBooking : this.compProps.needNoRepositoty,
              this.compProps.mode,
              this.houseFilter.checkInDate,
              this.houseFilter.checkOutDate,
              this.houseFilter.visible && this.houseFilter.onlyCanBooking,
              false,
              cityId
            )
            let havePriceData = ret.data || {}
            if ((havePriceData.items && havePriceData.items.length !== ids.length) || !havePriceData.items) {
              // 返回的有报价和所有房屋数量不等，请求第二次获取全部房屋，包括无报价
              noHavePriceHouse = await this.fetchHouseHandle(this.compProps.isOutOfOrder ? this.changeSort(ids) : ids, aIds || [], this.compProps.priceTime, maxShowNumber, this.$root.promotionId,
                this.houseFilter.visible ? !this.houseFilter.onlyCanBooking : this.compProps.needNoRepositoty,
                this.compProps.mode,
                this.houseFilter.checkInDate,
                this.houseFilter.checkOutDate,
                this.houseFilter.visible && this.houseFilter.onlyCanBooking,
                true,
                cityId
              )
              let noHavePriceData = noHavePriceHouse.data || {}
              let allArr = noHavePriceData.items?.map((noPrice) =>
                havePriceData.items?.find((havePrice) => havePrice.unitId === noPrice.unitId) || noPrice
              )
              havePriceData.items = allArr ? [...allArr] : []
              havePriceData.totalCount = noHavePriceData.totalCount || 0
            }
          } else {  // 可订
            ret = await this.fetchHouseHandle(this.compProps.isOutOfOrder ? this.changeSort(ids) : ids, aIds || [], this.compProps.priceTime, maxShowNumber, this.$root.promotionId,
              this.houseFilter.visible ? !this.houseFilter.onlyCanBooking : this.compProps.needNoRepositoty,
              this.compProps.mode,
              this.houseFilter.checkInDate,
              this.houseFilter.checkOutDate,
              this.houseFilter.visible && this.houseFilter.onlyCanBooking,
              false,
              cityId
            )
          }
        } else if (this.compProps.houseChoice === '2') {
          // 存cookie，用于node的搜索接口，访客模式也出价格
          if (!Cookies.get('mkt_flag') && Cookies.get('_visitor_flag') === 'visitor000000') {
            Cookies.set('mkt_flag', true)
          }
          /**
           * 存cookie，用于node的侧获取房屋价格，用于客户端展示价格一致
           * TOC-9086【T增长】CMS房屋卡片报价不一致 通过Cookies中的 tj_channel_wrapper_id 判断
           */
          if(!Cookies.get('tj_channel_wrapper_id') && this.judgeIsTuJiaAppEnv) {
            Cookies.set('tj_channel_wrapper_id', 'waptujia001')
          }

          // 搜索系统
          const params = {
            pageIndex: 0,
            pageSize: maxShowNumber,
            conditions: []
          }
          /**
           * 用于node的侧获取房屋价格，用于客户端展示价格一致
           * TOC-9086【T增长】CMS房屋卡片报价不一致
           */
          if (this.judgeIsTuJiaAppEnv) {
            params.client = {
              uID: tjCookie.getDeviceId()
            }
          }
          /**
           * TOC-5607 H5配置后台功能增强一期C - 房屋列表增加选项
           * 城市是否收全局城市控制，因为线上是默认受控的，为了保持线上一致
           * 所以 isCityControl 为 false， 为不受控
           * 其他值都为受控
           */
          const cityId = this.compProps.isCityControl === false? '': this.houseFilter.cityId
          // 城市，字符串
          params.conditions.push({ type: 1, value: String(cityId || this.compProps.searchCityId || '8')})
          // 入离
          let checkInDate = this.houseFilter.checkInDate
          let checkOutDate = this.houseFilter.checkOutDate
          if ((!this.houseFilter.checkInDate || !this.houseFilter.checkOutDate) && Number(this.compProps.priceTime) > 1) {
            let moment = require('moment')
            checkInDate = moment().add('days', Number(this.compProps.priceTime) - 1).format('YYYY-MM-DD')
            checkOutDate = moment().add('days', Number(this.compProps.priceTime)).format('YYYY-MM-DD')
          }
          checkInDate ? params.conditions.push({ type: 2, value: checkInDate }) : null
          checkOutDate ? params.conditions.push({ type: 3, value: checkOutDate }) : null
          // 价格
          this.compProps.minPrice || this.compProps.maxPrice ? params.conditions.push({ type: 7, value: `${this.compProps.minPrice || 0},${this.compProps.maxPrice || 100000}` }) : null
          // 筛选项
          const labelIds = this.compProps.labelIds && this.compProps.labelIds.split(',') || []
          labelIds.forEach((item) => {
            item && params.conditions.push({ type: 6, value: String(item) })
          })
          ret = await searchHouse(params)
          if (ret && ret.errcode === 0) {
            const data = ret.data || {}
            data.items && data.items.forEach((item) => {
              // 房屋id，用于查收藏
              ids.push((item.unitId))
              // 是否可定
              item.allowBooking = item.failType === 0
              if (!item.priceTags || item.priceTags.length === 0) {
                const priceTagText = item.priceTagVO?.totalReduceAmount || item.priceTipBadge?.text || ''
                if (priceTagText) {
                  item.priceTags = [{ text: priceTagText }]
                }
              }
            })
          }
        } else if (this.compProps.houseChoice === '3') {
          // 专属房源，无报价无库存同样展示
          this.compProps.houses.forEach((house) => {
            ids.push(house.id)
          })
          const checkInDate = this.$route?.query?.priceCheckInDate || null
          const checkOutDate = this.$route?.query?.priceCheckOutDate || null
          const aIds = this.compProps.promotionId && this.compProps.promotionId.split(',')
          ret = await this.fetchHouseHandle(ids, aIds || [], this.compProps.priceTime, maxShowNumber, this.$root.promotionId,
            true, this.compProps.mode, checkInDate, checkOutDate,
            false,
            false
          )
          let havePriceData = ret.data || {}
          if ((havePriceData.items && havePriceData.items.length !== ids.length) || !havePriceData.items) {
            // 返回的有报价和所有房屋数量不等，请求第二次获取全部房屋，包括无报价
            noHavePriceHouse = await this.fetchHouseHandle(ids, aIds || [], this.compProps.priceTime, maxShowNumber, this.$root.promotionId, 
              true, this.compProps.mode, checkInDate, checkOutDate,
              false,
              true
            )
            let noHavePriceData = noHavePriceHouse.data || {}
            let allArr = noHavePriceData.items?.map((noPrice) =>
              havePriceData.items?.find((havePrice) => havePrice.unitId === noPrice.unitId) || noPrice
            )
            havePriceData.items = allArr ? [...allArr] : []
            havePriceData.totalCount = noHavePriceData.totalCount || 0
          }
          eventBus.$emit('exclusiveHouse', havePriceData?.items?.[0] || {})
        }

        // 查询收藏
        let faviroteRet = null
        let faviroteIds = []
        if (this.$root.isLogin) {
          faviroteRet = await fetchFavirote(ids)
          if (faviroteRet && faviroteRet.errcode === 0) {
            faviroteIds = faviroteRet.data?.houseIdList || []
          }
        }

        // 处理返回
        // 处理最大值
        let total = 0
        let items = []
        if (ret && ret.errcode === 0 && ret.data) {
          total = ret.data.totalCount || 0
          items = ret.data.items || []
        }
        if (total > +maxShowNumber) {
          total = +maxShowNumber
          items = items && items.splice(0, total)
        }
        // 处理收藏、priceTags、hasSpecialTags
        let hasPriceTags = false
        let hasSpecialTags = false
        items = items && items.map((item) => {
          let house = item
          if (this.compProps.houseChoice === '0') {
            house = this.compProps.houses.find((itemHouse) => {
              return itemHouse.id + '' === item.unitId + ''
            })
          }
          const favirote = faviroteIds.find((faviroteId) => {
            return faviroteId === item.unitId
          })
          let priceTags = item.priceTags || []
          if (priceTags && priceTags.length > 0) {
            hasPriceTags = true
          }
          let specialTags = item.specialTags || []
          if (specialTags.length > 0) {
            hasSpecialTags = true
          }
          return {
            ...item,
            priceTags,
            comment: house.comment,
            houseLabels: house.labels,
            isLike: favirote !== undefined
          }
        })
        items = items && items.map((item) => {
          return {
            ...item,
            hasPriceTags,
            hasSpecialTags
          }
        })
        const data = {
          totalCount: total,
          items: items || []
        }
        this.$emit('init', data)
      } catch (e) {
        this.msg = '系统开小差了，一会再试试吧' // 已经领取过了 // 好可惜，红包抢完了 // 系统开小差了，一会再试试吧
        this.showToast = true
        errorReport(e)
      }
    },
    changeSort(arr) {
      if (!arr) {
        return []
      }
      let array = JSON.parse(JSON.stringify(arr))
      let j, x, i
      for (i = array.length; i; i--) {
        j = Math.floor(Math.random() * i)
        x = array[i - 1]
        array[i - 1] = array[j]
        array[j] = x
      }
      return array
    },
    autoLinkApp(src) {
      // TUDO: isJumpApp 需要添加
      let timer = setTimeout(() => {
        window.location.href = src
        clearTimeout(timer)
      }, 500)
    },
    /**
     *
     * 支付宝webview下跳转逻辑
     */
    jumpAliClientAndMP(id, isJump) {
      this.getAliEnv().then((res) => {
        if (res) {
          // mp
          window.location.href = `${this.mTujiaHost}/detail/${id}.htm?dg=1`
        } else {
          if (isJump) {
            const appId = 2018101061620818
            const mpPage = encodeURIComponent('pages/unitDetails_v2/unitDetails')
            // beginDate=2019-06-08&endDate=2019-06-09&unitId=241557&peopleCount=1
            const mpQuery = `unitId=${id}`
            // eslint-disable-next-line no-undef
            window.location.href = `alipays://platformapi/startapp?appId=${appId}&page=${mpPage}&query=${encodeURIComponent(mpQuery)}`
          } else {
            window.location.href = `${this.mTujiaHost}/detail/${id}.htm?dg=1`
          }
        }
      })
    },
    getAliEnv() {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        my.getEnv((res) => {
          if (res && res.miniprogram) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    },
    async fetchHouseHandle() {
      /**
       * 用于node的侧获取房屋价格，用于客户端展示价格一致
       * TOC-9086【T增长】CMS房屋卡片报价不一致
       */
      let args = Array.from(arguments);
      // 如果是在途家APP中 给client字段赋值
      if (this.judgeIsTuJiaAppEnv) {
        const additionalParams = {
          uID: tjCookie.getDeviceId()
        };
        args.push(additionalParams);
      }
      return this.$root.isFetchHouseNewForCMS ? fetchHouseNew(...args) : fetchHouse(...arguments)
    }
  }
}
</script>
